import React from 'react';
import { Badge, Button, Modal } from 'antd';
import pickBy from 'lodash/pickBy';
import difference from 'lodash/difference';
import { Field } from 'redux-form';
import { TextField, TextAreaField, SelectField, NumberField } from 'redux-form-antd';
import RangePicker from '../../molecules/RangePicker';
import FormValueSelector from '../../../containers/FormValueSelector';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

let warn = [];

const warnKeys = [
  'io_value',
  'agency',
  'billing_customer',
  'billing_email',
  'sales_person',
  'account_manager',
  'reporting_lead',
  'actor_id',
  'advertiser_uuid',
  'vertical',
  'seller_pub_uuid',
];

const IODetails = ({
  agencies,
  billing_customers,
  billing_emails,
  campaign,
  visibleModal,
  hideModal,
  showModal,
  handleSubmit,
  loading,
  verticalOptions,
  advertiserOptions,
  adminOptions,
  salesOptions,
  publisherOptions,
}) => {
  return [
    <FormValueSelector key={1} selector={(select, form, sectionPrefix, values) => values}>
      {values => {
        warn = difference(warnKeys, Object.keys(pickBy(values)));
        return (
          <Badge count={warn.length}>
            <Button size="large" onClick={showModal}>
              View IO Details
            </Button>
          </Badge>
        );
      }}
    </FormValueSelector>,
    <Modal
      key={2}
      width={800}
      title={`IO Details for ${campaign.name}`}
      visible={visibleModal}
      confirmLoading={loading}
      onOk={handleSubmit}
      okText="Update"
      onCancel={hideModal}
    >
      <form onSubmit={handleSubmit} className="ioForm">
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('name')}>Name</Badge>}
          name="name"
          component={TextField}
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('io_number')}>IO No.</Badge>}
          name="io_number"
          component={TextField}
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('io_value')}>IO Value</Badge>}
          name="io_value"
          style={{ width: 300 }}
          format={value => (!value ? '' : `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','))}
          parse={value => (!value ? '' : parseFloat(`${value}`.replace(/\$\s?|(,*)/g, '')))}
          component={NumberField}
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('po_number')}>PO No.</Badge>}
          name="po_number"
          component={TextField}
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('agency')}>Agency</Badge>}
          name="agency"
          mode="tags"
          showSearch
          component={SelectField}
          options={agencies.map(a => ({
            title: a,
            label: a,
            value: a,
          }))}
          placeholder="Select an agency"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('billing_customer')}>Billing Customer</Badge>}
          name="billing_customer"
          showSearch
          mode="tags"
          component={SelectField}
          options={billing_customers.map(a => ({
            title: a,
            label: a,
            value: a,
          }))}
          placeholder="Select a billing customer"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('billing_email')}>Billing Email</Badge>}
          name="billing_email"
          mode="tags"
          showSearch
          component={SelectField}
          options={billing_emails.map(a => ({
            title: a,
            label: a,
            value: a,
          }))}
          placeholder="Select a billing email"
        />
        <Field
          {...formItemLayout}
          mode="multiple"
          label={<Badge dot={warn.includes('sales_person')}>Salesperson</Badge>}
          name="sales_person"
          showSearch
          optionFilterProp="title"
          optionLabelProp="title"
          component={SelectField}
          options={salesOptions}
          placeholder="Select a salesperson"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('account_manager')}>Account Manager</Badge>}
          name="account_manager"
          format={a => a && `${a}`}
          showSearch
          optionFilterProp="title"
          optionLabelProp="title"
          component={SelectField}
          options={salesOptions}
          placeholder="Select an account manager"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('reporting_lead')}>Reporting Lead</Badge>}
          name="reporting_lead"
          optionFilterProp="title"
          optionLabelProp="title"
          format={a => a && `${a}`}
          showSearch
          component={SelectField}
          options={adminOptions}
          placeholder="Select a reporting lead"
        />
        <Field
          {...formItemLayout}
          optionFilterProp="title"
          optionLabelProp="title"
          label={<Badge dot={warn.includes('actor_id')}>Campaign Lead</Badge>}
          name="actor_id"
          format={a => a && `${a}`}
          showSearch
          component={SelectField}
          options={adminOptions}
          placeholder="Select or type a campaign lead"
        />
        <Field
          {...formItemLayout}
          optionFilterProp="title"
          optionLabelProp="title"
          label={<Badge dot={warn.includes('advertiser_uuid')}>Advertiser</Badge>}
          name="advertiser_uuid"
          showSearch
          component={SelectField}
          options={advertiserOptions}
          placeholder="Select or type an advertiser"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('vertical')}>Vertical</Badge>}
          name="vertical"
          format={a => a && `${a}`}
          showSearch
          component={SelectField}
          options={verticalOptions}
          placeholder="Select a vertical"
        />
        <RangePicker
          formItemLayout={formItemLayout}
          showTime={false}
          displayFormat="YYYY-MM-DD"
          apiFormat="YYYY-MM-DD"
        />{' '}
        <Field
          {...formItemLayout}
          optionFilterProp="title"
          optionLabelProp="title"
          label={<Badge dot={warn.includes('seller_pub_uuid')}>Seller (Publisher)</Badge>}
          name="seller_pub_uuid"
          disabled
          showSearch
          component={SelectField}
          options={publisherOptions}
          placeholder="Select a seller"
        />
        <Field
          {...formItemLayout}
          label={<Badge dot={warn.includes('billing_notes')}>Notes</Badge>}
          name="billing_notes"
          placeholder="Notes for billing"
          component={TextAreaField}
        />
      </form>
    </Modal>,
  ];
};

export default IODetails;
